import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { black, MQ } from '@css/constants'

export const MiniPopupWrapper = styled('div')(css`
  color: ${black};
  padding: 0 18px;
  margin-top: 20px;
  text-align: center;

  ${MQ.MOBILE_XS} {
    margin-top: -20px;
    margin-bottom: 20px;
  }
  ${MQ.MOBILE} {
    margin-top: -20px;
    margin-bottom: 20px;
  }
`)

export const Title = styled('div')(css`
  ${FontNormal(600)};
  ${fontSize(20)};

  sup {
    ${fontSize(12)};
  }
`)

export const CustomContent = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
`)

export const CloseIconWrapper = styled('div')(css`
  & > svg {
    height: 18px;
    width: 18px;
  }
`)
